import React from "react";
import styled from "styled-components";
import { Icon } from "@abb/abb-common-ux-react";
import { SubHeader } from "../../../../framework/components/styled/SubHeader";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: red;
  gap: ${props => props.theme.sizes.s};
`;

export const OrderCancelledInfo = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container>
      <IconTextWrapper>
        <Icon name="abb/warning-circle-1" sizeClass="large" />
        <SubHeader text={t("Order cancelled")} />
      </IconTextWrapper>
    </Container>
  );
};
